/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactInfo/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Emails from './Emails/index'
import No from './No/index'
import Phones from './Phones/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ContactInfo({
  children,
  viewPath = "/DesignSystem/PatientInformation/Content/Relations/Content/Relation/ContactInfo"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
  return (<React.Fragment
>
<div
  data-testid="ContactInfo.Vertical"
  data-view-path={viewPath}
 style={{'--btlr-1-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-2-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-3-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-4-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-5-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-6-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-7-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-8-21nK64': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-9-21nK64': dtColorsWhite,'--bc-10-21nK64': dtColorsNeutral100}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<No
  viewPath={`${viewPath}/No`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
<Emails
  viewPath={`${viewPath}/Emails`}
/>
</div>
{children}
</React.Fragment>)
}